<div class="confirm-plan-dialog">

  <h2 class="dialog-title">Confirmar cambio de plan</h2>
  <p class="dialog-subtitle">Estás a punto de activar el siguiente plan</p>

  <div class="plan-summary">
    <div class="plan-name-row">
      <span class="plan-label">Plan</span>
      <span class="plan-value">{{ plan?.title }}</span>
    </div>
    <div class="plan-name-row">
      <span class="plan-label">Facturación</span>
      <span class="plan-value">{{ period === 'year' ? 'Anual' : 'Mensual' }}</span>
    </div>
    <div class="plan-name-row" *ngIf="couponApplied && couponDiscount > 0">
      <span class="plan-label">{{ couponDescription || 'Cupón' }} ({{ couponCode }})</span>
      <span class="plan-value discount-value">- {{ couponDiscount | number:'1.2-2' }} €</span>
    </div>
    <div class="plan-name-row plan-total-row" *ngIf="showCatalogTotal">
      <span class="plan-label">Total</span>
      <span class="plan-value total-value">{{ total | number:'1.2-2' }} €/{{ periodLabel }}</span>
    </div>
    <convfact-plan-change-preview
      *ngIf="isPlanChange"
      [planAlias]="plan?.id"
      [period]="period"
      [renewalAmount]="total"
      (stateChange)="onPreviewState($event)">
    </convfact-plan-change-preview>
  </div>

  <p class="billing-note" *ngIf="couponApplied && couponNote">{{ couponNote }}</p>

  <p class="billing-note" *ngIf="billingText && !(isPlanChange && preview.loaded)">{{ billingText }}</p>

  <div class="dialog-actions">
    <button type="button" class="btn-back" (click)="cancel()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
    <button type="button" class="btn-confirm" (click)="confirm()" [disabled]="preview.loading">
      Confirmar y activar
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

</div>
